import Checkbox from '@berlitz/checkbox'
import { H2 } from '@berlitz/globals'
import { Attachment } from '@berlitz/icons'
import Spacer from '@berlitz/spacer'
import TextArea from '@berlitz/text-area'
import PortalPrograms from '@classes/Programs'
import PortalRegistrations from '@classes/Registrations'
import Alert from '@components/Alert'
import EmptyState from '@components/EmptyState'
import FileUpload from '@components/Fileupload'
import FilenameWithIcon from '@components/Fileupload/FileContainer'
import Input from '@components/Input'
import RoleBasedView from '@components/RoleBasedView'
import Select from '@components/Select'
import TextBoxArea from '@components/TextBoxArea'
import { ToasterProps, withToaster } from '@components/Toaster'
import WithUserTimeHOC, { WithUserTimeProps } from '@hocs/WithUserTime'
import QueryResult from '@interfaces/QueryResult'
import { StoreProps } from '@interfaces/StoreState'
import { POST_CASE } from '@mutations/cases'
import { GET_CASES } from '@queries/cases'
import { charLimit, PROFILE_TYPE, REG_STATUS, textInputLimit } from '@utils/constants'
import { getFileExtension } from '@utils/helpers'
import { getIcon } from '@utils/helpers/fileicons'
import { categories } from '@utils/stubdata/support-categories.json'
import get from 'lodash/get'
import { WithRouterProps } from 'next/dist/client/with-router'
import Router, { withRouter } from 'next/router'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Layout from '../Layout'
import { convertPortalToSFValue } from '../typeMapping'
import ContactDashboard from './DashboardV2'
import { ContactProps, ContactState, ContactType } from './interface'
import { BoldP, FooterButton, HeaderButton, ProgramLabel, ProgramSelect, StyledCol, StyledP, StyledRow } from './style'

type ContactCombinedProps = InjectedIntlProps & ToasterProps & ContactProps & WithUserTimeProps & WithRouterProps

const NoProgram = 'Na'

class Contact extends React.Component<ContactCombinedProps, ContactState> {
  constructor(props: ContactCombinedProps) {
    super(props)

    const defaultProgram = []
    const PPrograms = new PortalPrograms(props.StudentPrograms)
    const PRegistrations = new PortalRegistrations(props.StudentRegistrations)
    const programs = props.StudentPrograms.length
      ? defaultProgram.concat(PPrograms.studentProgramsSortedDropdown(props.getDateWithUserTimezone))
      : []
    const registrations = props.StudentRegistrations.length
      ? [...PRegistrations.studentSortedRegDropdown(PRegistrations.RegistrationNames), ...defaultProgram]
      : []

    let RegistrationId = get(props.router, 'query.pid', NoProgram)

    if (
      registrations.length &&
      (!registrations.find(prog => prog.value === RegistrationId) || RegistrationId === NoProgram)
    ) {
      RegistrationId = registrations[0]?.value
    }

    this.state = {
      Subject: '',
      Description: '',
      uploadedFiles: [],
      charLimitExceeds: false,
      SFId: props.SFId,
      userType: props.UserType,
      programs,
      registrations,
      RegistrationId,
      LessonNow: 'No',
      OtherSubType: '',
      submitted: false,
      ...this.formState(props.router, categories as ContactType[]),
      hasFlexPrograms: PPrograms.hasFlexPrograms(),
    }
  }

  formState = (router, data: ContactType[]) => {
    const activeRoute = router.query
    const openFile = false

    if (!activeRoute || (activeRoute && !activeRoute.caseType)) {
      return {
        active: '',
        openFile,
      }
    }

    const active = activeRoute.caseType
    const activeTypeDetails = data.find(item => item.slug === active)
    const Type = activeTypeDetails
      ? convertPortalToSFValue(activeTypeDetails.caseType || activeTypeDetails.title) ||
        activeTypeDetails.caseType ||
        activeTypeDetails.title
      : ''

    return {
      active,
      activeTypeDetails,
      openFile,
      Type,
    }
  }

  handleCasePostSubmit = data => {
    const { intl, toaster } = this.props
    const isSuccess = !!get(data, 'postCase.Success')
    const toasterInfo = isSuccess
      ? {
          type: 'success',
          msg: 'Case successfully submitted',
        }
      : {
          type: 'error',
          msg: 'Error in submitting case',
        }

    toaster[toasterInfo.type](
      intl.formatMessage({
        id: toasterInfo.msg,
      })
    )
    this.setState({
      Description: '',
      uploadedFiles: [],
      OtherSubType: '',
      charLimitExceeds: false,
      submitted: isSuccess,
    })
  }

  componentDidUpdate(prevProps): void {
    if (prevProps.router && this.props.router && prevProps.router.asPath !== this.props.router.asPath) {
      this.setState({
        ...this.formState(this.props.router, categories as ContactType[]),
        LessonNow: 'No',
      })
    }
  }

  onChangeArea = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      SubType: e.target.value,
    })
  }

  onChangeOtherSubType = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      OtherSubType: e.target.value,
    })
  }

  onChangeSubject = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const charLimitExceeds = value.length > textInputLimit
    const Subject = charLimitExceeds ? this.state.Subject : value

    this.setState({
      Subject,
    })
  }

  onChangeIssueValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const charLimitExceeds = value.length > charLimit
    const Description = charLimitExceeds ? this.state.Description : value

    this.setState({
      Description,
      charLimitExceeds,
    })
  }

  formNewCase = () => {
    const {
      Type,
      SubType,
      Subject,
      Description,
      uploadedFiles,
      userType,
      SFId,
      RegistrationId,
      LessonNow,
      OtherSubType,
    } = this.state
    const FileInfos =
      uploadedFiles &&
      uploadedFiles.map(file => {
        return {
          Title: file.name,
          FileUrl: file.url,
          [`${userType}Profile`]: SFId,
        }
      })
    const CaseInfo = {
      Type,
      SubType: (document.querySelector('input[name=SubType]') as HTMLInputElement | null)?.value || undefined,
      Subject,
      Description,
      LessonNow,
      [`${userType}Id`]: SFId,
      caseCommentInfoList: [],
    }
    if (SubType === 'Other') {
      CaseInfo.OtherSubType = OtherSubType
    }

    if (userType === PROFILE_TYPE.STUDENT && RegistrationId !== NoProgram) {
      CaseInfo.RegistrationId = RegistrationId
    }

    return [
      {
        FileInfos,
        CaseInfo,
      },
    ]
  }

  setProgramId = value => {
    this.setState({
      ProgramId: value,
    })
  }

  setRegistrationId = value => {
    this.setState({
      RegistrationId: value,
    })
  }

  render() {
    const { intl } = this.props
    const { userType, SFId, RegistrationId, registrations, submitted } = this.state
    const { active, Subject, Description, uploadedFiles, LessonNow } = this.state

    const getQueryVariables = {
      Id: SFId,
      Type: userType,
      UserId: SFId,
    }

    const programSelector =
      userType === PROFILE_TYPE.STUDENT && registrations.length > 1 ? (
        <StyledRow>
          <StyledCol lg={6} md={12} sm={12} xs={12}>
            <ProgramSelect>
              <ProgramLabel>
                <div>
                  <FormattedMessage id="Program" />:
                </div>
              </ProgramLabel>
              <Select
                label=""
                name="Program"
                value={RegistrationId}
                onChange={this.setRegistrationId}
                options={registrations}
                disableMargin
                responsive
              />
            </ProgramSelect>
          </StyledCol>
          <Alert alertType="info" dismissable={false}>
            <FormattedMessage id="To help us direct your request please select a course." />
          </Alert>
        </StyledRow>
      ) : null

    if (submitted) {
      return (
        <EmptyState
          heading="Thanks for contacting us"
          bodyTxt="We'll be in touch as soon as possible. In the meantime feel free to check out our FAQ section."
          img="/images/thank-you.svg"
          linkUrl="/support"
          btnTxt="Go to FAQ"
        />
      )
    }

    return (
      <Layout activeMainNav={'Contact us'}>
        <H2>
          <FormattedMessage id="Contact us" />
          <Query query={GET_CASES} variables={getQueryVariables} fetchPolicy="network-only">
            {({ data }: QueryResult) =>
              data && data.getCases && data.getCases.length > 0 ? (
                <HeaderButton onClick={() => Router.push('/support/requests')}>
                  <FormattedMessage id="View previous support requests" />
                </HeaderButton>
              ) : null
            }
          </Query>
        </H2>
        <Spacer />
        {programSelector}
        <StyledP>
          <FormattedMessage id="To get started please select a support area" />
        </StyledP>
        <Spacer size="lg" />
        <ContactDashboard items={categories as ContactType[]} active={active} />
        {active ? (
          <Mutation mutation={POST_CASE}>
            {(postCase: any, { loading }) => (
              <>
                <Spacer />
                {active === 'technical-support' && (
                  <>
                    <Checkbox
                      checked={LessonNow === 'Yes'}
                      label={intl.formatMessage({ id: 'In lesson now', defaultMessage: 'In lesson now' })}
                      name={'LessonNow'}
                      value={LessonNow === 'Yes' ? 'No' : 'Yes'}
                      onChange={e => {
                        this.setState({
                          LessonNow: e.target.value,
                        })
                      }}
                    />
                    <Spacer />
                  </>
                )}
                {categories
                  .filter(({ slug }) => slug === active)
                  .map(item => {
                    return (
                      <RoleBasedView key={item.id} configId={item.action!}>
                        <Input type="hidden" name="SubType" value={item.subType} />
                      </RoleBasedView>
                    )
                  })}

                <BoldP>
                  <FormattedMessage id="Subject" />
                </BoldP>
                <Spacer />
                <TextBoxArea value={Subject} maxlength={textInputLimit}>
                  <Input value={Subject} onChange={this.onChangeSubject} name="Subject" label="" />
                </TextBoxArea>
                <Spacer />
                <BoldP>
                  <FormattedMessage id="What's on your mind?" />
                </BoldP>
                <Spacer />
                <TextBoxArea value={Description} maxlength={charLimit}>
                  <TextArea
                    data-e2e="support-case-textarea"
                    name="issue"
                    value={Description}
                    onChange={this.onChangeIssueValue}
                  />
                </TextBoxArea>
                <FileUpload
                  open={!!this.state.openFile}
                  onClose={() => {
                    this.setState({ openFile: false })
                  }}
                  saveText="Attach and exit"
                  closeOnSave={true}
                  onSave={files => {
                    this.setState({
                      uploadedFiles: files,
                    })
                  }}
                />
                {uploadedFiles && (
                  <div style={{ display: 'inline-block' }}>
                    <Spacer />
                    {uploadedFiles.map(file => {
                      const { Icon } = getIcon(getFileExtension(file.name))
                      return (
                        <FilenameWithIcon name={file.name} key={file.path}>
                          <Icon size="sm" />
                        </FilenameWithIcon>
                      )
                    })}
                  </div>
                )}
                <Spacer />
                <FooterButton
                  className="support-case-submit"
                  canLoad
                  loading={loading ? 1 : 0}
                  disabled={!Subject.length || !Description.length}
                  loadingText={intl.formatMessage({ id: 'Submitting' })}
                  onClick={async () => {
                    const { data } = await postCase({
                      variables: {
                        caseInput: this.formNewCase(),
                      },
                      refetchQueries: [
                        {
                          query: GET_CASES,
                          variables: getQueryVariables,
                        },
                      ],
                      awaitRefetchQueries: true,
                    })

                    this.handleCasePostSubmit(data)
                  }}
                >
                  <FormattedMessage id="Submit" />
                </FooterButton>
                <FooterButton outline onClick={() => this.setState({ openFile: true })}>
                  <Attachment size="24" /> <FormattedMessage id="Attach file" />
                </FooterButton>
                <Spacer size="xxxl" />
                <Spacer size="xxxl" />
              </>
            )}
          </Mutation>
        ) : null}
      </Layout>
    )
  }
}

const mapStateToProps = ({ userProfile }: StoreProps) => ({
  SFId: get(userProfile, 'info.SFId'),
  UserType: get(userProfile, 'info.Type'),
  StudentPrograms: get(userProfile, 'info.StudentProfile.StudentProfileInfo.ProgramStudentWrappers', []),
  StudentRegistrations: get(userProfile, 'info.StudentProfile.StudentProfileInfo.RegistrationWrappers', []).filter(
    ({ RegistrationInfo }) =>
      [REG_STATUS.PAUSED, REG_STATUS.CANCELLED, REG_STATUS.DRAFT].indexOf(RegistrationInfo.Status) < 0
  ),
})

const withConnect = connect(mapStateToProps, {})

export default compose(withRouter, injectIntl, withToaster, WithUserTimeHOC, withConnect)(Contact)
